// extracted by mini-css-extract-plugin
export default {"kycContainer":"KYCMessage_kycContainer__RJUVr","message":"KYCMessage_message__atseL","kycButton":"KYCMessage_kycButton__MsreX"};